import { apiRequest } from '@scc/lib'
import type {
  ScorecardsRepository,
  WeekStart,
} from '@/data/repositories/types'
import type { WeeklyScorecard, MonthlyScorecard } from '@/modules/scorecards/types'

interface ApiWeeklyRow {
  weekStarting: string
  weekEnding: string
  gmv: number
  grossRevenue: number
  orders: number
  customers: number
  visitors: number
  cvr: number
  adSpend: number
  roas: number
  videosPosted: number
  videoViews: number
  videoGpm: number
  liveGmvPct: number
  videoGmvPct: number
  affiliateGmvPct: number
}

interface ApiMonthlyRow {
  month: number
  year: number
  gmv: number
  growthVsPrevMonth: number
  grossRevenue: number
  aov: number
  asp: number
  liveGmvPct: number
  videoGmvPct: number
  productCardGmvPct: number
  affiliateGmvPct: number
  visitors: number
  cvr: number
  customers: number
  adSpend: number
  roas: number
  videosPosted: number
  videoViews: number
  videoGpm: number
}

function basePath(clientId: string): string {
  return `/clients/${encodeURIComponent(clientId)}/scorecards`
}

export function createApiScorecardsRepository(): ScorecardsRepository {
  return {
    async getWeeklyScorecard(clientId, weekStart: WeekStart = 'monday') {
      const rows = await apiRequest<ApiWeeklyRow[]>(
        `${basePath(clientId)}/weekly?weekStart=${weekStart}`,
      )
      return rows.map((r): WeeklyScorecard => ({ clientId, ...r }))
    },
    async getMonthlyScorecard(clientId) {
      const rows = await apiRequest<ApiMonthlyRow[]>(`${basePath(clientId)}/monthly`)
      return rows.map((r): MonthlyScorecard => ({ clientId, ...r }))
    },
  }
}

export const scorecardsRepository = createApiScorecardsRepository()
